import type { RouteObject } from 'react-router-dom';

import { Layout } from '@/components/Layout';
import { RequireAuth } from '@/features/auth/RequireAuth';
import { AlertsPage } from '@/pages/Alerts';
import { AssignmentsPage } from '@/pages/Assignments';
import { AuditPage } from '@/pages/Audit';
import { CalendarPage } from '@/pages/Calendar';
import { CompliancePage } from '@/pages/Compliance';
import { DashboardPage } from '@/pages/Dashboard';
import { DocumentsPage } from '@/pages/Documents';
import { EmployeeDetailPage } from '@/pages/EmployeeDetail';
import { EmployeesPage } from '@/pages/Employees';
import { JobDetailPage } from '@/pages/JobDetail';
import { JobsPage } from '@/pages/Jobs';
import { LeavePage } from '@/pages/Leave';
import { MessagesPage } from '@/pages/Messages';
import { PayrollPage } from '@/pages/Payroll';
import { InventoryPage } from '@/pages/Inventory';
import { InventoryDetailPage } from '@/pages/InventoryDetail';
import { InventoryQuickScanPage } from '@/pages/InventoryQuickScan';
import { InventoryScanPage } from '@/pages/InventoryScan';
import { VehicleDetailPage } from '@/pages/VehicleDetail';
import { VehiclesPage } from '@/pages/Vehicles';
import { RecycleBinPage } from '@/pages/RecycleBin';
import { SettingsPage } from '@/pages/Settings';
import { ShiftDetailPage } from '@/pages/ShiftDetail';
import { ShiftsPage } from '@/pages/Shifts';
import { SitesPage } from '@/pages/Sites';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <RequireAuth>
        <Layout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'shifts', element: <ShiftsPage /> },
      { path: 'shifts/:id', element: <ShiftDetailPage /> },
      { path: 'calendar', element: <CalendarPage /> },
      { path: 'leave', element: <LeavePage /> },
      { path: 'payroll', element: <PayrollPage /> },
      { path: 'assignments', element: <AssignmentsPage /> },
      { path: 'jobs', element: <JobsPage /> },
      { path: 'jobs/:id', element: <JobDetailPage /> },
      { path: 'employees', element: <EmployeesPage /> },
      { path: 'employees/:id', element: <EmployeeDetailPage /> },
      { path: 'sites', element: <SitesPage /> },
      { path: 'documents', element: <DocumentsPage /> },
      { path: 'messages', element: <MessagesPage /> },
      { path: 'compliance', element: <CompliancePage /> },
      { path: 'alerts', element: <AlertsPage /> },
      { path: 'audit', element: <AuditPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'inventory', element: <InventoryPage /> },
      { path: 'inventory/:id', element: <InventoryDetailPage /> },
      { path: 'vehicles', element: <VehiclesPage /> },
      { path: 'vehicles/:id', element: <VehicleDetailPage /> },
      /* What a scanned label resolves to. Same component as the detail page — the
         server turns a code into an item, so this is only a different way in. */
      { path: 'inventory/scan/:code', element: <InventoryScanPage /> },
      /* The camera version, and the manifest's start_url: opening the installed app
         puts you on the scanner, because that is the reason it is installed. */
      { path: 'inventory/scan', element: <InventoryQuickScanPage /> },
      { path: 'recycle-bin', element: <RecycleBinPage /> },
    ],
  },
];
